import React, { useEffect, useContext } from "react";
import FifoTabs from "../../components/_fifoTabs";
import RoleChecker from "../../../../utils/roleChecker";
import authService from "../../../../services/authService";
import EntityContext from "../../../../context/entityContext";
import NoAccess from "../../widgets/noAccess";
import { browserHistory } from "react-router";
import { Helmet } from "react-helmet";
import ProcessingFacility from "../../widgets/general/processingFacility";
import { TradeFinanceProvider, TradeFinanceContext } from "../../../../context/tradeFinanceContext";

//export default function TFLayout (props) {
const TFLayout = (props) => {
    const { children, location } = props;

    const { handleProductChange, selectedBusinessType, handleRoleChange, selProduct, accountDetails, entityDetails } = useContext(EntityContext);
    const { constants, products } = authService.getCurrentUser();

    useEffect(() => {

        handleProductChange(constants.PRODUCTS.TRADEFINANCE);

        if(selectedBusinessType === null || selectedBusinessType === 'ALL'){
            if(RoleChecker.check(products, constants.ROLES.TFCUSTOMER))
                handleRoleChange(constants.BUSINESS_TYPE.PURCHASE);
            else if(RoleChecker.check(products, constants.ROLES.TFSUPPLIER))
                handleRoleChange(constants.BUSINESS_TYPE.SALE);
            else
                browserHistory.push('/client/home')
        }
    }, []);

    const accountInfo = accountDetails.find(item => item.product == constants.PRODUCTS.TRADEFINANCE);
    const productSettings = entityDetails.productSettings.find(item => item.id == constants.PRODUCTS.TRADEFINANCE);

    return(
        <div>
            {( (!accountInfo || !productSettings.default_settings_available) && ( props.location.query && props.location.query.type != 'sale') && selectedBusinessType === constants.BUSINESS_TYPE.PURCHASE) ? (
                <ProcessingFacility />
            )
            :
            selProduct === constants.PRODUCTS.TRADEFINANCE ? 
                <>
                    <Helmet>
                        <title>{accountInfo ? accountInfo.nick_name ? accountInfo.nick_name : accountInfo.bank_account_name : ''} | {global.config.title}</title>
                    </Helmet>
                    <FifoTabs 
                        activePath={props.location.pathname.substring(
                            props.location.pathname
                        )} 
                    />
                    {props.children}
                </> : 
                <NoAccess />
            }
        </div>
    )    
}

const WrappedTradeFinanceLayout = (props) => (
  <TradeFinanceProvider>
    <TFLayout {...props} />
  </TradeFinanceProvider>
);

export default WrappedTradeFinanceLayout;